/* BRAVA FALL ACTIVATION START */
(() => {
  const host = document.getElementById('brava-fall-leaves');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const colors = ['#a25c40', '#6a3036', '#73503b', '#c3a589', '#b6743e'];
  const paths = [
    'M16 2C12 7 4 10 5 20C6 28 14 31 20 26C28 19 24 8 16 2Z',
    'M16 2L20 10L26 7L25 15L31 17L24 22L25 28L18 26L16 32L14 25L6 28L8 21L1 17L8 14L6 7L13 10Z',
    'M27 3C14 3 3 9 4 21C5 29 13 29 18 24C24 18 24 10 27 3Z'
  ];
  function build() {
    host.replaceChildren();
    if (reduced.matches) return;
    const count = mobile.matches ? 5 : 10;
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < count; i++) {
      const leaf = document.createElement('span');
      leaf.className = 'brava-fall-leaf';
      const duration = host.dataset.page === 'product' ? 14 + Math.random() * 2 : 10 + Math.random() * 6;
      const vars = {
        '--x': ((i + Math.random() * .6) / count * 100) + '%',
        '--size': (mobile.matches ? 14 + Math.random() * 7 : 17 + Math.random() * 11) + 'px',
        '--duration': duration + 's', '--delay': (-Math.random() * duration) + 's',
        '--opacity': (.45 + Math.random() * .27).toFixed(2),
        '--rotation': (Math.random() * 100 - 50) + 'deg',
        '--sway': (16 + Math.random() * 42) * (i % 2 ? -1 : 1) + 'px',
        '--drift': (Math.random() * 70 - 35) + 'px'
      };
      Object.entries(vars).forEach(([key,value]) => leaf.style.setProperty(key,value));
      leaf.style.color = colors[i % colors.length];
      leaf.innerHTML = '<svg viewBox="0 0 34 36" aria-hidden="true" focusable="false"><path fill="currentColor" d="' + paths[i % paths.length] + '"/><path d="M16 32L17 10M16 22L10 17M17 18L22 13" fill="none" stroke="#eadac8" stroke-opacity=".4" stroke-width=".7"/></svg>';
      fragment.append(leaf);
    }
    host.append(fragment);
  }
  function visibility() { host.dataset.paused = String(document.hidden); }
  reduced.addEventListener('change',build);
  mobile.addEventListener('change',build);
  document.addEventListener('visibilitychange',visibility);
  visibility();
  build();
})();
/* BRAVA FALL ACTIVATION END */
